import { RequestTraining } from "@feature/request-training";
import { memo } from "react";

const RequestTrainingPage = memo(() => {
  return <RequestTraining />;
});

export default RequestTrainingPage;
